import React from "react";

export interface CommuCategoryChild {
    ctgrCd: string;
    subCtgrCd?: string;
    ctgrNm: string;
}

export interface CommuCategoryNode {
    ctgrCd: string;
    ctgrNm: string;
    children?: CommuCategoryChild[];
}

interface CommuCategoryAccordionMenuProps {
    categories: CommuCategoryNode[];
    expandedCategory: string;
    activeBoardCode: string;
    activeSubCode?: string;
    className?: string;
    onCategorySelect: (boardCode: string) => void;
    onSubMenuSelect?: (boardCode: string, subCode: string) => void;
    onSubMenuClickAfter?: () => void;
}

const CommuCategoryAccordionMenu = ({
    categories,
    expandedCategory,
    activeBoardCode,
    activeSubCode = "",
    className = "",
    onCategorySelect,
    onSubMenuSelect,
    onSubMenuClickAfter,
}: CommuCategoryAccordionMenuProps) => {
    return (
        <div className={className}>
            <ul>
                {categories.map((category) => {
                    const isExpanded = expandedCategory === category.ctgrCd;
                    const hasChildren = !!category.children && category.children.length > 0;

                    return (
                        <li key={category.ctgrCd}>
                            <div
                                className={activeBoardCode === category.ctgrCd ? "active" : ""}
                                onClick={() => onCategorySelect(category.ctgrCd)}
                                style={{ cursor: "pointer" }}
                            >
                                <p>{category.ctgrNm}</p>
                                <span className={`category-arrow ${isExpanded ? "up" : "down"}`}></span>
                            </div>
                            {isExpanded && hasChildren && (
                                <ul className="guideSubAccordionList">
                                    {category.children?.map((sub) => {
                                        const subCode = sub.subCtgrCd || sub.ctgrCd;
                                        return (
                                            <li
                                                key={subCode}
                                                className={activeSubCode === subCode ? "active" : ""}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onSubMenuSelect?.(category.ctgrCd, subCode);
                                                    onSubMenuClickAfter?.();
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <p>{sub.ctgrNm}</p>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default CommuCategoryAccordionMenu;
